module.exports = __webpack_public_path__ + "img/in.6f836d36.svg";